import React, { useState, useEffect } from 'react'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import { ImSortAlphaAsc, ImSortAlphaDesc, ImSortAmountAsc, ImSortAmountDesc } from 'react-icons/im'

const EventTabTable = (props) => {  
  const { tab, data, dateExtended, label, categoryColors, hide, dark } = props
  const [page, setPage] = useState(0)
  const [dataOrdered, setDataOrdered] = useState(data)
  const [orderBy, setOrderBy] = useState("Type")
  const [orderAsc, setOrderAsc] = useState(true)  

  const getSortedData = (data, extended) => {
    data.forEach(element => {
      element[extended][0]["dm_coa"] = element[extended][0].Sales > 0 ? element[extended][0].Cost / element[extended][0].Sales : 0
      element[extended][0]["cpthousand"] = element[extended][0].Mailed > 0 ? element[extended][0].Cost / element[extended][0].Mailed * 1000 : 0
      element[extended][0]["total_coa"] = element[extended][0].Total_Sales > 0 ? element[extended][0].Cost / element[extended][0].Total_Sales : 0
      element[extended][0]["avg_ticket"] = element[extended][0].Responses > 0 ? element[extended][0].Sales / element[extended][0].Responses : 0
      element[extended][0]["pct_total"] = element[extended][0].Total_Sales > 0 ? element[extended][0].Sales / element[extended][0].Total_Sales : 0
    })

    if(orderAsc) {      
      if(orderBy === "Type") {                
        setDataOrdered(data.sort((a,b) => a.Label.localeCompare(b.Label)))
      } else {        
        setDataOrdered(data.sort((a,b) => a[dateExtended][0][orderBy] - b[dateExtended][0][orderBy]))
      }
    } else {
      if(orderBy === "Type") {
        setDataOrdered(data.sort((a,b) => b.Label.localeCompare(a.Label)))        
      } else {        
        setDataOrdered(data.sort((a,b) => b[dateExtended][0][orderBy] - a[dateExtended][0][orderBy]))
      }
    }
  }
  
  useEffect(() => {
    let dataSet = [...dataOrdered]
    getSortedData(dataSet, dateExtended)    
  }, [dateExtended])
  
  const handleChangePage = (e, page) => {
    setPage(page)
  }

  const handleSortColumn = (description) => {    
    let newOrdered = [...dataOrdered]
    
    if(orderAsc) {
      if(description === orderBy) {
        if(description === "Type") newOrdered.sort((a,b) => b.Label.localeCompare(a.Label))
        else newOrdered.sort((a,b) => b[dateExtended][0][description] - a[dateExtended][0][description])

        setDataOrdered(newOrdered)        
        setOrderAsc(!setOrderAsc)
      } else {
        if(description === "Type") newOrdered.sort((a,b) => a.Label.localeCompare(b.Label))      
        else newOrdered.sort((a,b) => a[dateExtended][0][description] - b[dateExtended][0][description])
        
        setDataOrdered(newOrdered)
        setOrderAsc(true)
        setOrderBy(description)
      }
    } else {
      if(description === "Type") newOrdered.sort((a,b) => a.Label.localeCompare(b.Label))      
      else newOrdered.sort((a,b) => a[dateExtended][0][description] - b[dateExtended][0][description])

      setDataOrdered(newOrdered)
      setOrderAsc(true)
      setOrderBy(description)
    }    
  }

  if(!dataOrdered) return <CircularProgress />

  const renderSort = (attr) => (    
    orderBy === attr ?
      orderAsc ?
      <ImSortAlphaAsc style={{marginLeft: "5px", color: "#fff"}}/> : <ImSortAlphaDesc style={{marginLeft: "5px", color: "#fff"}}/>
    : null    
  )

  return (
    <div>        
      <Table className="status-table" size="small">      
        <TableHead>
          <TableRow style={{height: "25px"}}>            
            <TableCell className={`table-head ${dark ? "dk" : "lt"}`} onClick={() => handleSortColumn("Type")}>
              {label} {renderSort("Type")}
            </TableCell>
            <TableCell className={hide ? "hide" : "table-head"} onClick={() => handleSortColumn("Cost")} align="right" style={{color: categoryColors[0]}}>
              Spend {renderSort("Cost")}
            </TableCell>
            <TableCell className="table-head" onClick={() => handleSortColumn("Mailed")} align="right" style={{color: categoryColors[1]}}>
              Mailed {renderSort("Mailed")}
            </TableCell>
            <TableCell className="table-head" onClick={() => handleSortColumn("Responses")} align="right" style={{color: categoryColors[2]}}>
              Responses {renderSort("Responses")}
            </TableCell>
            <TableCell className="table-head" onClick={() => handleSortColumn("Sales")} align="right" style={{color: categoryColors[3]}}>
              Sales {renderSort("Sales")}
            </TableCell>
            <TableCell className="table-head" onClick={() => handleSortColumn("Res_Rate")} align="right" style={{color: categoryColors[4]}}>
              Response Rate {renderSort("Res_Rate")}
            </TableCell>
            <TableCell className="table-head" onClick={() => handleSortColumn("dm_coa")} align="right" style={{color: categoryColors[5]}}>
              DM CoA {renderSort("dm_coa")}
            </TableCell>
            <TableCell className={hide ? "hide" : "table-head"} onClick={() => handleSortColumn("cpThousand")} align="right" style={{color: categoryColors[6]}}>
              Cost Per Thousand {renderSort("cpThousand")}
            </TableCell>
            <TableCell className={hide ? "hide" : "table-head"} onClick={() => handleSortColumn("total_coa")} align="right" style={{color: categoryColors[7]}}>
              Total CoA {renderSort("total_coa")}
            </TableCell>
            <TableCell className={hide ? "hide" : "table-head"} onClick={() => handleSortColumn("avg_ticket")} align="right" style={{color: categoryColors[8]}}>
              Average Ticket {renderSort("avg_ticket")}
            </TableCell>
            <TableCell className={hide ? "hide" : "table-head"} onClick={() => handleSortColumn("Total_Sales")} align="right" style={{color: categoryColors[9]}}>
              Total Sales {renderSort("Total_Sales")}
            </TableCell>
            <TableCell className="table-head" onClick={() => handleSortColumn("pct_total")} align="right" style={{color: categoryColors[10]}}>
              % of Total Sales {renderSort("pct_total")}
            </TableCell>
            <TableCell className="table-head" align="right" style={{color: categoryColors[11]}}>
              Contribution Margin ROI
            </TableCell>
          </TableRow>
        </TableHead>        
        <TableBody>          
          {dataOrdered.slice(page * 10, page * 10 + 10)
            .map((row, i) => (
            <TableRow key={row.Key} className="event-table-row">
              <TableCell><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>{row.Label}</Typography></TableCell>
              <TableCell align="right" className={hide ? "hide" : ""}><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>${Math.round(row[dateExtended][0].Cost).toLocaleString("en")}</Typography></TableCell>
              <TableCell align="right"><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>{Math.round(row[dateExtended][0].Mailed).toLocaleString("en")}</Typography></TableCell>
              <TableCell align="right"><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>{Math.round(row[dateExtended][0].Responses).toLocaleString("en")}</Typography></TableCell>
              <TableCell align="right"><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>${Math.round(row[dateExtended][0].Sales).toLocaleString("en")}</Typography></TableCell>
              <TableCell align="right"><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>{(row[dateExtended][0].Res_Rate * 100).toFixed(2)}%</Typography></TableCell>              
              <TableCell align="right"><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>{row[dateExtended][0].dm_coa ? (row[dateExtended][0].dm_coa * 100).toFixed(2) : 0}%</Typography></TableCell>
              <TableCell align="right" className={hide ? "hide" : ""}><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>${Math.round(row[dateExtended][0].cpthousand).toLocaleString("en")}</Typography></TableCell>
              <TableCell align="right" className={hide ? "hide" : ""}><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>{(row[dateExtended][0].total_coa * 100).toFixed(2)}%</Typography></TableCell>
              <TableCell align="right" className={hide ? "hide" : ""}><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>${Math.round(row[dateExtended][0].avg_ticket).toLocaleString("en")}</Typography></TableCell>
              <TableCell align="right" className={hide ? "hide" : ""}><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>${Math.round(row[dateExtended][0].Total_Sales).toLocaleString("en")}</Typography></TableCell>
              <TableCell align="right"><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>{(row[dateExtended][0].pct_total * 100).toFixed(2)}%</Typography></TableCell>
              <TableCell align="right"><Typography variant="caption" className={dark ? "table-col-dk" : "table-col-lt"}>N/A</Typography></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={data.length}
        rowsPerPage={10}
        page={page}
        onChangePage={handleChangePage}
        style={{color: "#fff"}}
      />
    </div>
  )
}

export default EventTabTable
